import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledStickyHeader } from "./sticky-header.scss";
import PictureComponent from "/components/core/picture/picture-component";
import { circlesData } from "./consts";
const StickyHeader = (props)=>{
    const [activeCircle, setActiveCircle] = useState(null);
    const handleCircleClick = (id, label)=>{
        setActiveCircle(activeCircle === id ? null : id);
        const targetElement = document.getElementById(label);
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ _jsx(StyledStickyHeader, {
        children: circlesData.map((circle)=>/*#__PURE__*/ _jsx("div", {
                onClick: ()=>handleCircleClick(circle.id, circle.label),
                children: activeCircle === circle.id ? /*#__PURE__*/ _jsxs("div", {
                    className: "expanded-circle",
                    children: [
                        /*#__PURE__*/ _jsx(PictureComponent, {
                            src: circle.image
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "circle-text",
                            children: circle.label
                        })
                    ]
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "circle",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: circle.image
                    })
                })
            }, circle.id))
    });
};
export default withGenericConfig(StickyHeader);
